import Vue from 'vue';
import VueI18n, {LocaleMessages} from 'vue-i18n';
import {getEnv} from "@/modules/core/utils";

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
    const locales = require.context('', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: LocaleMessages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

export default new VueI18n({
    locale: getEnv("VUE_APP_I18N_LOCALE") || 'en',
    fallbackLocale: getEnv("VUE_APP_I18N_FALLBACK_LOCALE") || 'en',
    messages: loadLocaleMessages(),
});
